import React, { useRef, useState, useEffect } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend, Title } from "chart.js";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import { useNavigate } from "react-router-dom";
import { LEAD_STATUS_VALUES } from "../../constants/CONSTANT";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { formatDate } from "../../utils/helper";

Chart.register(ArcElement, Tooltip, Legend, Title, ChartDataLabels);

const DonutChart = ({ dateRange }) => {
  const navigate = useNavigate();
  const chartRef = useRef(null);
  const [refreshPage, setRefreshPage] = useState(false);
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "Lead Stage",
        data: [],
        backgroundColor: [],
        borderColor: [],
        borderWidth: 1,
        hoverOffset: 4,
      },
    ],
  });

  useEffect(() => {
    fetchLeadsData(dateRange);
    setRefreshPage(true);
  }, [dateRange]);

  // Function to assign colors based on lead statuses
  const assignColors = (labels) => {
    const leadStatusMap = LEAD_STATUS_VALUES.reduce((acc, status) => {
      acc[status.label] = status.css.backgroundColor;
      return acc;
    }, {});

    const backgroundColor = labels.map((label) => {
      return leadStatusMap[label] || "#CCCCCC"; // Default color if not found
    });

    const borderColor = backgroundColor.map((color) =>
      color.replace("0.2", "1")
    );

    return { backgroundColor, borderColor };
  };





  async function fetchLeadsData(dateRange) {
    try {

      const filterDate = {};
      if (Array.isArray(dateRange)) {
        const [fromDate, toDate] = dateRange;
        if (fromDate && toDate) {
          filterDate.fromDate = formatDate(fromDate);
          filterDate.toDate = formatDate(toDate);
        }
      }
      const fetchLeads = await fuziElevatorsApi.fetchLeadForDashboard(Object.keys(filterDate).length > 0 ? filterDate : null);
      console.log("Fetch Leads", fetchLeads);
      if (fetchLeads) {
        const stageCount = fetchLeads.reduce((acc, lead) => {
          acc[lead.lead_status] = (acc[lead.lead_status] || 0) + 1;
          return acc;
        }, {});

        const labels = Object.keys(stageCount);
        const data = Object.values(stageCount);
        const { backgroundColor, borderColor } = assignColors(labels);

        setChartData({
          labels: labels,
          datasets: [
            {
              ...chartData.datasets[0],
              data: data,
              backgroundColor: backgroundColor,
              borderColor: borderColor,
            },
          ],
        });
      } else {
        setChartData({
          labels: [],
          datasets: [
            {
              label: "Lead Stage",
              data: [],
              backgroundColor: [],
              borderColor: [],
              borderWidth: 1,
              hoverOffset: 4,
            },
          ],
        });
      }

    } catch (error) {
      console.error("Error fetching leads:", error);
    }
  }

  const options = {
    animation: {
      animateScale: true,
      animateRotate: true,
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
      },
      datalabels: {
        color: '#fff',
        formatter: (value, context) => {
          return value;
        },
      },
    },
    layout: {
      padding: {
        bottom: 10,
      },
    },
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const index = elements[0].index;
        const leadStatus = chartData.labels[index];
        onLeadStatusClick(leadStatus);
      }
    },
  };



  const onLeadStatusClick = (status) => {
    console.log("STATUS", status);
    navigate("/leads", { state: { leadStatus: status } });
  };

  return (
    <div
      style={{
        width: "600px",
        height: "400px",
        marginLeft: "auto",
        marginRight: "auto",
      }}
    >
      {refreshPage &&
        <div style={{ width: "100%", height: "100%" }}>
          <Doughnut ref={chartRef} data={chartData} options={options} />
        </div>
      }

    </div>
  );
};

export default DonutChart;